const KEY = '_mf_journey';
const MAX = 50;

export interface JourneyEntry {
  url: string;
  title: string;
  ts: number;
}

/** Respect Do-Not-Track and an explicit page opt-out flag. */
export function shouldTrack(): boolean {
  const nav = (globalThis as any).navigator;
  if (nav && nav.doNotTrack === '1') return false;
  const win = (globalThis as any).window;
  if (win && win.__mfDisableTracking === true) return false;
  return true;
}

/**
 * Append one page view to sessionStorage. Dedups consecutive same-url, caps to
 * the last MAX entries. Stores pathname only (no query/hash → privacy). Never
 * throws — sessionStorage may be unavailable (private mode / quota).
 */
export function recordPageView(
  storage: Storage,
  loc: { pathname: string },
  title: string,
  now: number,
): void {
  let arr: JourneyEntry[] = [];
  try {
    const raw = storage.getItem(KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) arr = parsed as JourneyEntry[];
    }
  } catch { /* corrupt → start fresh */ }

  const url = loc.pathname;
  const last = arr[arr.length - 1];
  if (last && last.url === url) return; // dedup consecutive

  arr.push({ url, title, ts: now });
  if (arr.length > MAX) arr = arr.slice(arr.length - MAX);

  try {
    storage.setItem(KEY, JSON.stringify(arr));
  } catch { /* quota / private mode → no-op */ }
}

// Auto-boot when loaded as a <script> in the browser. Never throws.
if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  try {
    if (shouldTrack()) {
      recordPageView(window.sessionStorage, window.location, document.title, Date.now());
    }
  } catch { /* never block the page */ }
}
